import React from 'react';
import './leadership.css';
import president from '../assets/leaders-images/president.jpg';
import secretary from '../assets/leaders-images/secretary.jpg';
import vicepresident from '../assets/leaders-images/vicepresident.jpg';
import jointsecretary from '../assets/leaders-images/joint-secretary.jpg';
import treasurer from '../assets/leaders-images/treasurer.jpg';
import sevanavibhagamcon from '../assets/leaders-images/sevanavibhagamcon.jpg';
import executive1 from '../assets/leaders-images/executive1.jpg';
import executive2 from '../assets/leaders-images/executive2.jpg';
import executive3 from '../assets/leaders-images/executive3.jpg';
import executive4 from '../assets/leaders-images/executive4.jpg';
import executive5 from '../assets/leaders-images/executive5.jpg';

const leaders = {
  topLeaders: [
    { title: 'President', name: 'ALEENA BINU', image: president },
    { title: 'Secretary', name: 'LIKHITHA MARIAM YOHANNAN ', image: secretary },
  ],
  executives: [
    { title: 'Vice President', name: 'SIVADA J ', image: vicepresident },
    { title: 'Joint Secretary', name: 'JESABELL JOBBY', image: jointsecretary },
    { title: 'Treasurer', name: 'ANJITHA T K', image: treasurer },
    { title: 'Sevana Vibhagom Convenor', name: 'ANURAG B S  ', image: sevanavibhagamcon },
  ],
  convenors: [
    { title: 'Executive Committee Member', name: 'ISABELLE ANNA JOSEPH ', image: executive1 },
    { title: 'Executive Committee Member', name: 'JWALA ROSE B', image: executive2 },
    { title: 'Executive Committee Member', name: 'DHWANI S', image: executive3 },
    { title: 'Executive Committee Member', name: 'AISHWARYA RAJ M  ', image: executive4 },
    { title: 'Executive Committee Member', name: 'ARCHITHA K SHIBU  ', image: executive5 },
  ],
};

const Leadership = () => {
  return (
    <div className="leadership-page">
      <h1>LEADERSHIP 2026-2027</h1>

      {/* President and Secretary Row */}
      <div className="leader-row">
        {leaders.topLeaders.map((leader, index) => (
          <div key={index} className="leader-card">
            <img src={leader.image} alt={leader.title} />
            <h3>{leader.title}</h3>
            <p>{leader.name}</p>
          </div>
        ))}
      </div>

      {/* Executives Row (4 members) */}
      <div className="leader-row">
        {leaders.executives.map((executive, index) => (
          <div key={index} className="leader-card">
            <img src={executive.image} alt={executive.title} />
            <h3>{executive.title}</h3>
            <p>{executive.name}</p>
          </div>
        ))}
      </div>

      {/* Convenors Row (5 members) */}
      <div className="leader-row">
        {leaders.convenors.map((convenor, index) => (
          <div key={index} className="leader-card">
            <img src={convenor.image} alt={convenor.title} />
            <h3>{convenor.title}</h3>
            <p>{convenor.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leadership;
